import { createElement, useCallback } from 'react'

export const useCreateContent = ({ data, components }): JSX.Element => {
  const createComponent = useCallback(
    (def) => {
      const type = def.type
        .split('')
        .map((str, index) => (!index ? str.toUpperCase() : str))
        .join('')

      if (!components[type]) {
        return null
      }

      const props = {
        ...def,
        key: Math.random() + new Date().getMilliseconds(),
      } || {
        key: Math.random() + new Date().getMilliseconds(),
      }
      const children = Array.isArray(def.text)
        ? def.text.map((c) => createComponent(c))
        : def.text

      return createElement(components[type], props, children)
    },
    [components]
  )

  return data.map((def) => createComponent(def))
}
